import { useState, useEffect }from 'react';
import defaultBackground from '../../../pics/backgrounds/happyTavern.png';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import IconExample from './IconExample';
import EditPositionDropdown from './EditPositionDropdown';
import EditTvTablePositionDropdown from './EditTvTablePositionDropdown';
import PlayerViewBloodPreview from './PlayerViewBloodPreview';
import magPlus from '../../../pics/icons/magPlus.PNG'
import magMinus from '../../../pics/icons/magMinus.PNG'
import OptionButton from '../OptionButton';
import { useUser } from '../../../../../../providers/UserProvider';

const PlayerViewBloodPreviewTabs = ({currentEncounter, setCurrentEncounter, socket}) => {

    const { username, prefs, setPrefs } = useUser();
    
    const [playerOptions, setPlayerOptions] = useState(currentEncounter.playerViewOptions.playerOptions);
    const [monsterOptions, setMonsterOptions] = useState(currentEncounter.playerViewOptions.monsterOptions);
    const [allyOptions, setAllyOptions] = useState(currentEncounter.playerViewOptions.allyOptions);
    const [tableViewOptions, setTableViewOptions] = useState(currentEncounter.playerViewOptions.tableViewOptions);

    const allSame = playerOptions.position === monsterOptions.position && playerOptions.position === allyOptions.position
    const [allPosition, setAllPosition] = useState(allSame ? playerOptions.position : 'Mixed');

    const [playerGlobalOptions, setPlayerGlobalOptions] = useState(prefs.playerViewGlobalOptions.playerOptions);
    const [monsterGlobalOptions, setMonsterGlobalOptions] = useState(prefs.playerViewGlobalOptions.monsterOptions);
    const [allyGlobalOptions, setAllyGlobalOptions] = useState(prefs.playerViewGlobalOptions.allyOptions);
    const [tableViewGlobalOptions, setTableViewGlobalOptions] = useState(prefs.playerViewGlobalOptions.tableViewOptions);

    const allSameGlobal = playerGlobalOptions.position === monsterGlobalOptions.position && playerGlobalOptions.position === allyGlobalOptions.position
    const [allPositionGlobal, setAllPositionGlobal] = useState(allSameGlobal ? playerGlobalOptions.position : 'Mixed');

    const [hideAll, setHideAll] = useState(currentEncounter.hideAll);
    const [useGlobal, setUseGlobal] = useState(prefs.useGlobalPvOptions);

    useEffect(() => {
        setPlayerOptions({...currentEncounter.playerViewOptions.playerOptions});
        setMonsterOptions({...currentEncounter.playerViewOptions.monsterOptions});
        setAllyOptions({...currentEncounter.playerViewOptions.allyOptions});
        setHideAll(currentEncounter.hideAll);
        setTableViewOptions({...currentEncounter.playerViewOptions.tableViewOptions});

    }, [currentEncounter.encounterGuid]);

    useEffect(() => {
        setCurrentEncounter({...currentEncounter, hideAll: hideAll });
        // eslint-disable-next-line
    }, [hideAll]);


    const hideAllToggle = (checked) => {
        setHideAll(checked)
        socket.emit("controlHideAllToggle", checked, currentEncounter.encounterGuid)
    } 

    const globalToggle = (checked) => {
        setUseGlobal(checked)
        setPrefs(prev => {return {...prev, useGlobalPvOptions: checked}})
        socket.emit("setUpdatePref", "useGlobalPvOptions", checked, username, currentEncounter.encounterGuid)
    } 

    return (
        <>
            <div style={{
                display: 'flex', 
                justifyContent: 'space-around',
                padding: '5px', 
                backgroundColor: 'rgba(233, 233, 233)',
                borderRadius: '5px'
            }}>
                <div className='pVChecks' style={{textUnderlineOffset: '3px', textDecoration: 'underline', textDecorationColor: '#c9827d'}}> 
                    <b>Hide All</b>
                    <input type="checkbox" checked={hideAll} onChange={(e) => hideAllToggle(e.target.checked)} style={{
                        animation: hideAll ? 'hideAllShadowPulse 3s ease-in-out infinite' : '',
                        accentColor: hideAll ? '#c9827d' : '#ccc', // checked color vs unchecked
                    }}/>
                </div>
                <div className='pVChecks' style={{textUnderlineOffset: '3px', textDecoration: 'underline', textDecorationColor: '#c9827d'}}> 
                    <b>Use Global</b>
                    <input type="checkbox" checked={useGlobal} onChange={(e) => globalToggle(e.target.checked)} style={{accentColor: '#963d37ff'}}/>
                </div>
            </div>
            <Tabs>
                <TabList>
                    <Tab><b>Encounter</b><i>{useGlobal ? '' : '- ACTIVE'}</i></Tab>
                    <Tab><b>Global</b><i>{useGlobal ? '- ACTIVE' : ''}</i></Tab>
                </TabList>
                <TabPanel key={'Encounter'}>
                    <PlayerViewBloodPreview 
                        label={"| Pv Options"}
                        type={"encounter"}  
                        currentEncounter={currentEncounter} 

                        parentObject={currentEncounter} 
                        setParentObject={setCurrentEncounter} 

                        playerOptions={playerOptions}
                        setPlayerOptions={setPlayerOptions}

                        allyOptions={allyOptions}
                        setAllyOptions={setAllyOptions}
                        
                        monsterOptions={monsterOptions}
                        setMonsterOptions={setMonsterOptions}

                        allPosition={allPosition}
                        setAllPosition={setAllPosition}

                        tableViewOptions={tableViewOptions}
                        setTableViewOptions={setTableViewOptions}

                        socket={socket}
                    />
                </TabPanel>

                <TabPanel key={'Global'}>
                    <PlayerViewBloodPreview 
                        label={"Global Pv Options"} 
                        type={"global"} 
                        username={username} 
                        currentEncounter={currentEncounter} 
                        
                        parentObject={prefs} 
                        setParentObject={setPrefs} 

                        playerOptions={playerGlobalOptions}
                        setPlayerOptions={setPlayerGlobalOptions}

                        allyOptions={allyGlobalOptions}
                        setAllyOptions={setAllyGlobalOptions}
                        
                        monsterOptions={monsterGlobalOptions}
                        setMonsterOptions={setMonsterGlobalOptions}

                        allPosition={allPositionGlobal}
                        setAllPosition={setAllPositionGlobal}

                        tableViewOptions={tableViewGlobalOptions}
                        setTableViewOptions={setTableViewGlobalOptions}

                        socket={socket}
                    />
                </TabPanel>
            </Tabs>           
        </>
    );
}

export default PlayerViewBloodPreviewTabs;